import React, { useEffect } from 'react';
import { Button, Modal, Pagination, Stack, Table, Tooltip, Whisper } from 'rsuite';
import globalIP from '@/GlobelIP';

const { Column, HeaderCell, Cell } = Table;
const CompactCell = props => <Cell {...props} style={{ padding: 4 }} />;
const CompactHeaderCell = props => <HeaderCell {...props} style={{ padding: 4 }} />;
const CustomCell = CompactCell;
const CustomHeaderCell = CompactHeaderCell;

const ViewModal = ({
    header,
    isModalOpen,
    setIsModalOpen,
    cataname,
    label,
    fetchProducts1,
    tableHeight,
    currentPage,
    handleOpenDimm,
    sizeshow,
    handleChangeLimitforviw,
    setPageView,
    pageview,
    metaview,
    cbm = true
  }) => {
    useEffect(() => {
      
      
      // console.log('fetchProducts1',fetchProducts1);
    }, [fetchProducts1])
  return (
    <div>
       <Modal size="full" open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Modal.Header>
            <Stack>
              <b>{header} Name :</b>
              <p style={{ marginLeft: '8px' }}>{`${cataname}`}</p>
            </Stack>
          </Modal.Header>
          <Modal.Body>
            <Table
            data={fetchProducts1}
              // data={fetchProducts1.sort((a, b) => {
              //   // Sort by id in ascending order
              //   return b.id - a.id; // Change to b.id - a.id for descending order
              // })}
              height={tableHeight}
              rowKey="id"
              cellBordered
              rowHeight={60}
              wordWrap="break-word"
              bordered
            >
              <Table.Column width={80} align="center" fixed>
                <HeaderCell>
                  <b>Sr. No.</b>
                </HeaderCell>
                <Cell>{(_, rowIndex) => (currentPage - 1) * 25 + rowIndex + 1}</Cell>
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>Image</b>
                </Table.HeaderCell>
                <Table.Cell>
                  {rowData => {
                    const renderTooltip = imageSrc => (
                      <Tooltip style={{ backgroundColor: 'white' }}>
                        <img
                          src={imageSrc}
                          alt="Product Image"
                          style={{ width: 400, height: 400, objectFit: 'contain' }}
                        />
                      </Tooltip>
                    );

                    return (
                      <Whisper
                        followCursor
                        trigger="hover"
                        placement="right"
                        speaker={renderTooltip(
                          `${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`
                        )}
                      >
                        <img
                          src={`${globalIP}${rowData?.attributes?.CoverImage?.data?.attributes?.url}`}
                          alt="Product Image"
                          style={{ width: 50, height: 50, objectFit: 'contain' }}
                        />
                      </Whisper>
                    );
                  }}
                </Table.Cell>
              </Table.Column>
              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.AliasCode}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductId" />
              </Table.Column>
              <Table.Column width={250} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Description}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.Description" />
              </Table.Column>
              <Table.Column width={250} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductName}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductName" />
              </Table.Column>
              {sizeshow ? (
                <Table.Column width={100} align="center">
                  <Table.HeaderCell>
                    <b>{label[0]?.attributes.SizeRange}</b>
                  </Table.HeaderCell>
                  <Table.Cell dataKey="attributes.SizeRange" />
                </Table.Column>
              ) : (
                <Table.Column width={150} align="center">
                  <Table.HeaderCell>
                    <b>{label[0]?.attributes.Sizeunit}</b>
                  </Table.HeaderCell>
                  <Table.Cell>
                    {rowData => {
                      const { Length, Width, Height, SizeUnit, SetStatus, SetSizes } = rowData.attributes;
                      if (SetStatus === 'Set' && Array.isArray(SetSizes)) {
                        return <Button active onClick={() => handleOpenDimm(rowData.attributes.SetSizes)}>View Size</Button>
                      }
                      else {
                        return `${Length} x ${Width} x ${Height} ${SizeUnit}`
                      }
                    }}
                  </Table.Cell>
                </Table.Column>
              )}
                {
                    cbm && 
                        (
                            <Table.Column width={100} align="center">
                                <Table.HeaderCell>
                                <b>{label[0]?.attributes.cbm}</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="attributes.cbm" />
                            </Table.Column>

                        )
                }

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.finish}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.FinishName" />
              </Table.Column>

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.color}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ColorName" />
              </Table.Column>

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.NetWgt}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.NetWeight" />
              </Table.Column>

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.Category}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.CategoryName" />
              </Table.Column>

              <Table.Column width={100} align="center">
                <Table.HeaderCell>
                  <b>{label[0]?.attributes.ProductType}</b>
                </Table.HeaderCell>
                <Table.Cell dataKey="attributes.ProductTypeName" />
              </Table.Column>

            </Table>
            <div style={{ padding: 20 }}>
              <Pagination
                prev
                next
                first
                last
                ellipsis
                boundaryLinks
                maxButtons={5}
                limit={25}
                size="xs"
                layout={['-', 'pager', 'skip']}
                total={metaview?.pagination?.total || 1}
                activePage={pageview}
                onChangePage={setPageView}
                onChangeLimit={handleChangeLimitforviw}
              />
            </div>
          </Modal.Body>
        </Modal>
    </div>
  );
};

export default ViewModal;
